<template>
	<div>
    <van-overlay :show="show" z-index="2020" @click="show = false" >
      <div class="test_triangle_border" v-show="show">
        <div class="popup" @click="buttonClick">
          <van-icon name="cross" color="#fffff" class="close"/>
          点击 <span style="font-size:20px;line-height: 20px;">···</span>
          选择<span style="margin:0 4px">“发送给朋友”</span>~
        </div>
      </div>
    </van-overlay>
	</div>
</template>

<script>
	import addApplets from "@/components/addApplets.vue";
	export default {
		props: {
			
		},
		components: {

		},
		data() {
			return {
				show:false
			};
		},
		methods: {
			buttonClick: function() {
				this.show=true;
			},
			closeapplets: function() {
				this.show=false;
				this.show=!this.show
			},
		},
	};
</script>

<style lang="scss" scoped>

.bottom-button {
	width: 282px;
  height: 62px;
	border: 2px solid #333333;
	border-radius: 31px;
	font-size: 24px;
	color: #333333;
	display: flex;
	align-items: center;
	justify-content: center;
	margin: 0 auto;
}

.test_triangle_border .popup {
	width: 380px;
	line-height: 40px;
	font-size: 26px;
	background: #111;
	padding: 15px 20px;
	color: #fff;
	border-radius: 15px;
	position: fixed;
	top: 20px;
	right: 15px;
	border: 1px solid #111;
}

.test_triangle_border .popup::before {
	content: '';
	width: 0px;
	height: 0px;
	border-width: 0 20px 20px;
	border-style: solid;
	border-color: transparent transparent #111;
	right: 60px;
	top: -15px;
	position: absolute;
	margin-left: -10px;
}
.close{
	position: absolute;
	top: 15px;
	right: 10px;
}
</style>
